import {MuWidget} from "mu-widget/lib/MuWidget";

export class UiPager extends MuWidget {
	public get itemPerPage(): number {
		const v = this.ui.itemPerPage.valueAsNumber;
		return v == NaN ? 100 : Math.max(v, 1);
	}
	public set itemPerPage(v) {
		this.ui.itemPerPage.valueAsNumber = v;
	}
	public get currentItemFrom(): number {
		return this.currentPageNum * this.itemPerPage;
	}
	public currentPageNum: number = 0;

	public bChangeItemPerPage_click() {
		this.setPageNum(this.currentItemFrom / this.itemPerPage, true);
	}

	pageItems: UiPagerItem[] = [];
	beforeIndex() {
		this.muRegisterEvent('changePage');
		this.muAppendContent(`
			<ul mu-id="pages" class="pagination ui-pager--pages"><li mu-widget="UiPagerItem" mu-template="item"><a mu-id="label"></a></li></ul>
			<div class="ui-pager--item-per-page input-group">
				<input type="number" mu-id="itemPerPage" value="100" class="form-control" />
				<span class="input-group-btn"><span class="btn btn-default" mu-id="bChangeItemPerPage">Zobraz</span></span>
			</div>
		`);
		this.container.classList.add('ui-pager');
	}

	public setPageNum(current: number, launchEvent: boolean = false) {
		for(const item of this.pageItems) item.setSelected(item.num == current);
		this.currentPageNum = current;
		if (launchEvent) this.muDispatchEvent('changePage', current);
	}

	public setPageCount(count: number) {
		this.ui.pages.innerHTML = "";
		for(let n = 0; n < count; n++) {
			this.pageItems[n] = this.muWidgetFromTemplate('item', 'pages', {num: n}) as unknown as UiPagerItem;
		}
		this.setPageNum(this.currentPageNum, false);
	}

	public setItemCount(count: number) {
		this.setPageCount(Math.ceil(count / this.itemPerPage));
	}
}

export class UiPagerItem extends MuWidget<UiPager> {
	public num: number;
	afterIndex() {
		this.ui.label.innerText = (this.num + 1).toString();
	}

	container_click() {
		this.muParent.setPageNum(this.num, true);
	}

	setSelected(val: boolean) {
		this.container.classList.toggle('active', val);
	}
}